import React from 'react';
import useStyle from './flatIcon.style';
import icons, { Icon } from '../index';
import { classNames } from '../../../../helpers/style/classNames';

export interface FlatIconProps {
  icon: Icon;
  color?: string;
  size?: 'small' | 'normal' | 'large';
}

export const FlatIcon = ({ icon, color, size = 'normal' }: FlatIconProps) => {
  const classes = useStyle({ color });
  const SvgIcon = icons[icon];

  const getSvgSize = (svgSize: FlatIconProps['size']) => {
    if (svgSize === 'small') return { width: '16px', height: '16px' };
    if (svgSize === 'normal') return { width: '24px', height: '24px' };
    if (svgSize === 'large') return { width: '33px', height: '33px' };
  };

  return (
    <div className={classNames([classes.root, classes[size]])}>
      <SvgIcon
        width={getSvgSize(size).width}
        height={getSvgSize(size).height}
      />
    </div>
  );
};
